import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { Button, colors, GeneralFormError, SplitScreen, Typography } from '@ui-components/neo.tax';

import { screenLg, screenMd, screenXl } from '@neo.tax/shared';

export const StyledSplitScreen = styled(SplitScreen)({
  height: '100vh',
});

const LoginAnimation = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const LoginRootContainer = styled.div(
  {
    animation: `${LoginAnimation} .7s ease-in-out`,
    margin: 'auto 6rem',
    maxWidth: '24rem',
    width: '24rem',
  },
  screenXl({ padding: '2rem 0', marginLeft: '5rem', marginRight: '5rem' }),
  screenLg({ width: '100%', marginLeft: 'auto', marginRight: 'auto' }),
  screenMd({ padding: '2rem 1.25rem' }),
);

export const SubmitButton = styled(Button)({
  margin: 0,
  width: '100%',
});

export const StyledGeneralFormError = styled(GeneralFormError)({
  textAlign: 'center',
});

export const StyledLinkText = styled(Typography)({
  color: colors.primary[600],
  '&:hover': {
    color: colors.primary[500],
  },
});

export const StyledInfoContainer = styled.div({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '1.25rem',
});
